<template>
  <div class="page-content">
    <nav class="page-breadcrumb" id="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">{{ breadcrumbA }}</li>
        <li class="breadcrumb-item active" aria-current="page">
          {{ breadcrumbB }}
        </li>
      </ol>
    </nav>

 

    <lista-carga v-if="load"></lista-carga>
    <div class="row" v-else>
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">

                <div class="row mb-3">
                    <div class="col">
                        <label class="mr-sm-2">Desde</label>
                        <input type="date" class="form-control mb-2 mr-sm-2" id='desdex'/>
                    </div>
                    <div class="col">
                        <label class="mr-sm-2" for="inlineFormCustomSelect">Hasta</label>
                        <input type="date" class="form-control mb-2 mr-sm-2" id='hastax'/>
                    </div>
                    <div class="col">
                        <label class="mr-sm-2 w-100" for="">&nbsp;</label>
                        <button  class="btn btn-md btn-success w-100" @click="obtenerLiquidacion()">Consultar Novedades</button>
                    </div>
                </div>

               <h4 id="leyend">Reporte de novedades desde el <span id="desde"></span> y el <span id="hasta"></span></h4>
               <br>
          


            <div class="table-responsive">
              <table
                id="novedades"
                class="table table-theme table-row v-middle"
              
              >
                <thead>
                  <tr>
                    <th><span class="text-muted">Plato</span></th>
                    <th><span class="text-muted">Total</span></th>
                 
                  </tr>
                </thead>
                <tbody>
                    <tr v-for="caso in novedades" :key="caso.codigo">
                       

                        <td :id="'key'+caso.fireId">{{ caso.plato }}</td>
                        <td class="text-sm text-wrap">{{ caso.total }}</td>
                      
                    </tr>
                </tbody>
              </table>

               <div class="alert alert-danger"  role="alert" id="alerta">
                                 Realize su consulta ingresando el rango de fechas que corresponda
                                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>



 <!-- Extra large modal -->


<div class="modal fade observado_modal" tabindex="-1" role="dialog" aria-labelledby="myExtraLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="card-body card-block">
        <div class="row">
          <div class="col-sm-12" style="background-color: #f9e8b7;padding: 10px;">
            
              

              <div class="form-group">
                    <label for="exampleFormControlTextarea1">Escribe la observación/detalle que explique el motivo del estado</label>
                    <textarea class="form-control" id="observacion" rows="5"></textarea>
                  </div>
           
          </div>
          <div class="card-footer">
            <div class="row">
              <div class="col-sm-6"><button class="btn btn-block btn-success" v-on:click="guardaObservacion()">Guardar</button></div>
              <div class="col-sm-6"><button  class="btn btn-block btn-danger" data-dismiss="modal" id="cerrar_modal">Cancelar</button></div>
            </div>  
          </div>
        </div>
      </div>

        <div id="historial"></div>


    </div>
  </div>
</div>

</template>

<script>
import axios from "axios";
import $ from "jquery";
import Swal from "sweetalert2";
require("datatables.net");
require("datatables.net-buttons/js/buttons.colVis.js")();
require("datatables.net-buttons/js/buttons.html5.js")();
require("datatables.net-buttons/js/buttons.flash.js")();
require("datatables.net-buttons/js/buttons.print.js")();
//require("../../../public/assets/css/data-table-estilos-propios.css");
const userData = JSON.parse(sessionStorage.getItem('userData'));

import firebase from "firebase/app";
import "firebase/database";

import ListaCarga from '../ListaCarga';

const userPermission = JSON.parse(sessionStorage.getItem('userPermisos'));

export default {
  name: "novedades",
  components: {ListaCarga},
  data: () => ({
    breadcrumbA: "Inicio",
    breadcrumbB: "Cantidades por empresa",
    descripcion: "Listado de totales de cantidades por empresas",
    novedades: [],
   
    load: true,

  }),
  methods: {

    b64toBlob(b64, onsuccess, onerror) {
    var img = new Image();

    img.onerror = onerror;

    img.onload = function onload() {
        var canvas = document.createElement('canvas');
        canvas.width = img.width;
        canvas.height = img.height;

        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        canvas.toBlob(onsuccess);
    };

    img.src = b64;
},

openWindow(key) {





$.ajax({
            type: 'get',
            url: 'https://aplicativos.firebaseio.com/novedades_usuarios_test/'+key+'.json?print=pretty',
            contentType: "application/json; charset=utf-8",
            traditional: true,
            success: function (datos) {
             

           

          


fetch(datos.certificado)
.then(response => response.blob())
.then(function(myBlob) {
  var objectURL = URL.createObjectURL(myBlob);
  window.open(objectURL, '_blank');
});


            }

            });




  


  

 
},

    isEditor(modulo){
      
          if (userPermission.find( record => record.ModulosAccess === modulo)) {
            var status =  userPermission.find( record => record.ModulosAccess === modulo).Editor;
            console.log(modulo+' : '+status)
            return status;
          }else{
            console.log(modulo+' : '+false)
            return false;
          }
        },

obtenerLiquidacion(){
  this.load = true;
 this.getNovedad();
},
  getNovedad(){

  
    var hoy = new Date();
    var mes = hoy.getMonth() + 1;
    var numeroMes = mes < 10 ? "0" + mes : mes;
    var dia = hoy.getDate();
    dia = dia < 10 ? "0" + dia : dia;
    var anio = hoy.getFullYear();
   

    var anterior  = new Date(hoy.setMonth(hoy.getMonth()-1));
    var mes_anterior = anterior.getMonth() + 1;
    var numeroMes_a = mes_anterior < 10 ? "0" + mes_anterior : mes_anterior;
    var dia_a = anterior.getDate();
    dia_a = dia_a < 10 ? "0" + dia_a : dia_a;
    var anio_a = anterior.getFullYear();

    //var mes_act = anio+"-"+numeroMes+"-15";

    //var mes_ant = anio_a+"-"+numeroMes_a+"-15";


    var mes_ant = $("#desdex").val();

    var mes_act = $("#hastax").val();






     axios.get("https://auth.foodservice.com.ar/?type=cantidadesxPlato&desde="+mes_ant+"&hasta="+mes_act+"&access_token=1234567")
      .then((response) => {
            var vue = this;
            var obs = 0;







            $.each(response.data, (ids, items) => {

             

                let caso = items;
               
              console.log(items)

             

            vue.novedades.push({
                                  
                                  plato: caso.plato,
                                  total: caso.total,
                                 

                                  
                              });


                       
               
                
            

              });


            this.load = false;
      })
      .then(()=>{

               $("#desde").html(mes_ant);
               $("#hasta").html(mes_act);
               $("#alerta").hide();
            $('#novedades').dataTable({

            "language": {
            "decimal": ",",
            "thousands": ".",
            "info": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
            "infoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
            "infoPostFix": "",
            "infoFiltered": "(filtrado de un total de _MAX_ registros)",
            "loadingRecords": "Cargando...",
            "lengthMenu": "Mostrar _MENU_ registros",
            "paginate": {
            "first": "Primero",
            "last": "Último",
            "next": "Siguiente",
            "previous": "Anterior"
            },
            "processing": "Procesando...",
            "search": "Buscar:",
            "searchPlaceholder": "Término de búsqueda",
            "zeroRecords": "No se encontraron resultados",
            "emptyTable": "Ningún dato disponible en esta tabla",
            "aria": {
            "sortAscending":  ": Activar para ordenar la columna de manera ascendente",
            "sortDescending": ": Activar para ordenar la columna de manera descendente"
            },
            },
            dom: 'Bfrtip',
            "scrollX": false, 
            "search": {regex:true},
           
            responsive: false,
            nowrap: false,
             "initComplete":function( settings, json){

              setTimeout(function(){
                 console.log("completo");
                $('#novedades').DataTable().order([7, 'desc']).draw();
              },2000)

             
            // call your function here
        },
          buttons: [
              'copy', 'excel', 'pdf', 'print'
          ],
            })



 const diasEntreFechas = (desde, hasta) => {

                            var dia_actual = desde;
                            var fechas = [];
                            while (dia_actual.isSameOrBefore(hasta)) {
                              fechas.push(dia_actual.format('YYYY-MM-DD'));
                              dia_actual.add(1, 'days');
                            }
                            return fechas;
                        };




      })

      },      
  

  /*  cambiarStatus(caso){
        let statusMensaje = (caso.statusMensaje == "Resuelto") ? "En espera" : "Resuelto"; 
        console.log('novedades_usuarios_test/' + caso.fireId);
        firebase.database().ref('novedades_usuarios_test/' + caso.fireId).update({
            status: statusMensaje,
        })
        .then(()=>{
            caso.status = !caso.status;
            caso.statusMensaje = statusMensaje;
        })
        .catch(e => {
            console.log(e);
        });
    }
  },*/

  cambiarStatus(event, caso){

            if (event.target.value=="Observado"||event.target.value=="Rechazado") {

            window.$('.modal').modal();
            localStorage.setItem("status_id",caso.fireId);
            localStorage.setItem("status_sms",event.target.value);

             caso.status = event.target.value;
             caso.statusMensaje = event.target.value;
            

            $("#historial").empty();
            }else{
         
                firebase.database().ref('novedades_usuarios_test/' + caso.fireId).update({
                    status: event.target.value,
                    obs:0

                })
                .then(()=>{
                    caso.status = event.target.value;
                    caso.statusMensaje = event.target.value;
                    $("#key"+caso.fireId).hide();
                })
                .catch(e => {
                    console.log(e);
                });
            }    
      },




      mensajes(){


            window.$('.modal').modal();
            $("#historial").empty();

                 axios.get("https://aplicativos.firebaseio.com/novedades_usuarios_test.json?orderBy=%22$key%22&equalTo=%22"+localStorage.getItem('status_id')+"%22&print=pretty")
                .then((response) => {

                    $.each(response.data,function(key,value){
                        $.each(value.observacion,function(k,v){
                            $("#historial").prepend("<center><div style='width:90%;padding:5px;border:1px solid #d2cbcb;margin-top:5px;margin-bottom:5px;margin:5px;text-align: left;padding-left: 15px;'><span style='color:#716868;'><i>"+v.timestamp+"</i></span><br><b>"+v.nombre+":</b> "+v.detalle+"<br></div></center>");
                        })
                    })


                });
                     


          
      },

      guardaObservacion(){



        const addZero =(i) => {
            if (i < 10) {
                i = "0" + i;
            }
            return i;
        }

                var h = new Date();
                var hora = addZero(h.getHours());
                var minutos = ("0" + h.getMinutes()).substr(-2);
                var segundos = ("0" + h.getSeconds()).substr(-2);
                var horaActual = hora +':'+ minutos +':'+ segundos;

                var today = new Date();
                var m = today.getMonth() + 1;
                var mes = m < 10 ? "0" + m : m;
                var dia = today.getDate();
                dia = dia < 10 ? "0" + dia : dia;
                var fechaActual = today.getFullYear() + "-" + mes + "-" + dia;
                var timestamp = fechaActual + " " + horaActual;


           
                firebase.database().ref('novedades_usuarios_test/' + localStorage.getItem('status_id')+'/observacion').push({
                    detalle: $("#observacion").val(),
                    timestamp:timestamp,
                    nombre:userData.leg_nombre+' '+userData.leg_apellido

                })
                .then(()=>{


                        firebase.database().ref('novedades_usuarios_test/' + localStorage.getItem('status_id')).update({
                          status: localStorage.getItem('status_sms'),
                           obs: 0

                        })
                        .then(()=>{
                          $(".comentario #key"+localStorage.getItem('status_id')).hide();
                        })
                        .catch(e => {
                          console.log(e);
                        });

                
                  $("#observacion").val("");

                    Swal.fire(
                                      "Observación creada correctamente!",
                                      "Su observación fue enviada al zonal que corresponda",
                                      "success"
                                    );

                                      setTimeout(function(){
                                          $("#cerrar_modal").click();
                                          console.log("ocultar noti")
                                          console.log(localStorage.getItem('status_id'))
                                            $(".comentario #key"+localStorage.getItem('status_id')).hide();
                                          

                                           setTimeout(function(){
                                         
                                                localStorage.removeItem('status_id');
                                            
                                            },3000);
                                            
                                      },1000);



                })
                .catch(e => {
                    Swal.fire(
                                      "Ups!, Ocurrio un error",
                                      "Revise su conexión a internet y vuelva a intentar",
                                      "error"
                                    );

                                      setTimeout(function(){
                                          $("#cerrar_modal").click();
                                      },1000);
                });




              
      },

      

    },
  async mounted() {
     

            
            this.load = false;



  }
}
</script>
